import WalletShow from '@/components/modules/wallet/show/index';

const wallet = [
  {
    path: '/wallet',
    name: 'Wallet',
    component: WalletShow,
    meta: {
      title: 'Wallet',
    },
  },
];

export default wallet;
